import styled from "styled-components";
import { Type } from "@ebscois/react-component-library";

export const Wrapper = styled.div`
  font-size: ${({ theme }) => theme.font.size.sm};
  width: 100%;
`;

export const EndorserLabel = styled(Type)`
  i {
    font-style: italic;
  }
`;

export const EndorsersLogo = styled.img`
  ${(props) => {
    const isHIGN = props["data-endorser-id"] === "hign";
    const width = isHIGN ? "7.25rem" : "14.25rem";
    const height = isHIGN ? "auto" : "4.93rem";

    return `
      width: ${width};
      height: ${height};
    `;
  }}
  object-fit: contain;
  margin-bottom: ${({ theme }) => theme.space.sm};
`;
